import axios from 'axios'

const AppointmentConcernTypeService = {
  async getList (params = {}) {
    return axios.get('admin/appointment-concern-types', { params })
  },

  async show (id) {
    return axios.get(`admin/appointment-concern-types/${id}`)
  },

  async store (data) {
    return axios.post('admin/appointment-concern-types', data)
  },

  async update (id, data) {
    return axios.put(`admin/appointment-concern-types/${id}`, data)
  },

  async destroy (id) {
    return axios.delete(`admin/appointment-concern-types/${id}`)
  }
}

export default AppointmentConcernTypeService
